<header class="header">
  <nav class="navbar navbar-expand-lg">
    <div class="search-panel">
      <div class="search-inner d-flex align-items-center justify-content-center">
        <div class="close-btn">Close <i class="fa fa-close"></i></div>
        <form id="searchForm" action="#">
          <div class="form-group">
            <input type="search" name="search" placeholder="What are you searching for..." />
            <button type="submit" class="submit">Search</button>
          </div>
        </form>
      </div>
    </div>
    <div class="container-fluid d-flex align-items-center justify-content-between">
      <div class="navbar-header">
        <!-- Navbar Header--><a [routerLink]="['/home']" class="navbar-brand">
          <div class="brand-text brand-big visible text-uppercase">
            <img src="assets/images/logo1.png" width="170px" />
          </div>
          <div class="brand-text brand-sm"><strong class="text-primary blue">H</strong><strong>P</strong></div>
        </a>
        <!-- Sidebar Toggle Btn-->
        <button class="sidebar-toggle"><i class="fa fa-long-arrow-left"></i></button>
      </div>

      <!-- Log out               -->
      <div class="list-inline-item logout">
        <a id="logout" (click)="logout()" class="nav-link cursor-pointer">Logout <i class="icon-logout"></i></a>
      </div>
    </div>
  </nav>
</header>
<div class="d-flex">
  <app-header></app-header>
  <router-outlet></router-outlet>
</div>
